//
//

import {
    mapGetters, mapActions, mapMutations, mapState
} from "vuex";
import { date, debounce } from "quasar";
import { APP_DATE_DOT_FORMAT, ENGINE_REST_PATH } from "@/assets/js/appConfig";
import AQEmptySearch from "@/components/Generics/AQEmptySearch/AQEmptySearch.vue";
import membersListInfo from "@/components/tasks/membersListInfo/membersListInfo.vue";
import AQDropdown from "@/components/Generics/AQDropdown/AQDropdown.vue";
import AQChip from "@/components/Generics/AQChip/AQChip.vue";
import UnclaimReassignModal from "@/components/tasks/unclaimReassign/unclaimReassignModal.vue";
import TasksUtils from "@/components/UserInterfaces/mixins/tasks-utils";
import AQButton from "@/components/Generics/AQButton/AQButton.vue";
import AQMenu from "@/components/Generics/AQMenu/AQMenu.vue";
import AQCheckbox from "@/components/Generics/AQCheckbox/AQCheckbox.vue";
import AQTooltip from "@/components/Generics/AQTooltip/AQTooltip.vue";
import AQInput from "@/components/Generics/AQInput/AQInput.vue";
import AQDataTable from "@/components/Generics/AQDataTable/AQDataTable.vue";
import AQSearch from "@/components/Generics/AQSearch/AQSearch.vue";
import TasksStatus from "@/components/Dashboard/tasksStatusWidget.vue";
import AQEmptyState from "@/components/Generics/AQEmptyState/AQEmptyState.vue";
import SortIconsComponent from "./sortIcons.vue";
import {
    TASKS_CLAIMED_NEW, TASKS_STATUS_NEW, TABLE_DEFAULT_COLUMNS, SETTINGS_ALL_COLUMNS, SETTINGS_COLUMNS_MY_OPEN, TASKS_STATUS_UPDATED,
    DEFAULT_COL_SETTINGS_OPEN, DEFAULT_COL_SETTINGS_TEAM, SETTINGS_ACTIONS_BUTTONS, DEFAULT_COL_SETTINGS_COMPLETED, DEFAULT_COL_SETTINGS_TEAM_COMPLETED,
    SETTINGS_COLUMNS_COMPLETED, SETTINGS_COLUMNS_TEAMS_COMPLETED, COMPLETED_TASKS_COMPONENTS
} from "./constants";

export default {
    name: "AllTasksPage",

    components: {
        membersListInfo,
        SortIconsComponent,
        AQDataTable,
        AQEmptySearch,
        AQEmptyState,
        UnclaimReassignModal,
        AQDropdown,
        AQButton,
        AQInput,
        AQChip,
        AQCheckbox,
        AQTooltip,
        AQMenu,
        AQSearch,
        TasksStatus
    },
    filters: {
        dateFormatter(dateToFormat) {
            const newData = dateToFormat ? date.formatDate(dateToFormat, APP_DATE_DOT_FORMAT).split(" ") : "";
            return newData ? `${newData[0]} at ${newData[1]}` : "";
        },
        assignmentTotalNumber(data) {
            const users = data && data.users ? data.users : [];
            const groups = data && data.groups ? data.groups : [];

            return `+${(users.length + groups.length) - 1}`;
        }

    },
    mixins: [TasksUtils],
    props: {
        type: {
            require: true,
            type: String
        },
        dashboard: {
            type: Boolean,
            default: false
        },
        dashboardType: {
            type: String,
            default: ""
        },
        resetFilters: {
            type: Boolean,
            default: false
        },
        resetSelectedValues: {
            type: Boolean,
            default: false
        },
        fromAdmin: {
            type: Boolean
        },
        selectedTab: {
            type: String,
            default: ""
        },
        updateTaskList: {
            type: Boolean,
            default: false
        },
        hideOverview: {
            type: Boolean,
            default: false
        },
        hideTasklist: {
            type: Boolean,
            default: false
        }
    },
    data() {
        return {
            getDataFirstTime: true,
            showColSettings: false,
            showSearch: false,
            columnListSettingsChanged: false,
            columnsListToShow: [],
            selectedColumnSettings: [],
            settingsActionsButtons: SETTINGS_ACTIONS_BUTTONS,
            defaultColumnSettings: SETTINGS_ALL_COLUMNS,
            dashbordGroupId: [],
            initialStorageData: null,
            totalTasksToDisplay: 10,
            testList: [],
            allTasksClaimed: TASKS_CLAIMED_NEW,
            allTasksStatus: TASKS_STATUS_NEW,
            filterStatusOptions: TASKS_STATUS_UPDATED,
            allTasksData: [],
            allTasksTotalCount: 0,
            tasksCompletedTypes: COMPLETED_TASKS_COMPONENTS,
            dataGroups: [],
            dataUsersList: [],
            usersListOptions: [],
            appsOptions: [],
            processesOptions: [],
            showBtnGoOnTop: false,
            parentInstanceId: null,
            resetSelectedUsers: false,
            resetSelectedApps: false,
            resetSelectedFilt: false,
            resetAllSelectedData: false,
            changeUserList: false,
            currentSortValue: "",
            searchTasks: "",
            defaultStatusesValue: [],
            defaultTasksValue: [],
            defaultProcessesValue: [],
            defaultUsersValue: [],
            currentQueryParams: "",
            openSearch: false,
            columns: TABLE_DEFAULT_COLUMNS,
            paginationControl: { rowsPerPage: 0, page: 1 },
            tasksDisplayPayload: {
                pageSize: 10,
                pageNumber: 0,
                sortBy: "",
                sortType: "",
                groupId: "",
                users: [],
                applications: [],
                processes: [],
                statuses: [],
                searchValue: "",
                type: this.type,
                activeTasks: !COMPLETED_TASKS_COMPONENTS.includes(this.type)
            },
            remainingMembers: [],
            bulkTypeSelected: null,
            bulkCheckboxSelectedTasks: [],
            selectAllTasks: false,
            allTasksListIds: [],
            optionsMenu: "",
            showButtonBulkUnclaim: false,
            showButtonBulkReassign: false,
            bulkUnclaimReassignModal: false,
            managerDetailsData: null,
            currentSelectedTaskId: null,
            showTooltip: null,
            reassignAction: false,
            isOpen: this.type === "myOpenTasks",
            currentSortingPreferences: {
                sortBy: "",
                sortType: ""
            },
            noDataLoaded: true,
            loadingTable: true,
            firstLoad: true,
            showSettingsBtn: false,
            dataGroupsOptions: [],
            searchValue: "",
            savedUsers: [],
            filterTaskData: {
                tasks: [],
                statuses: [],
                users: [],
                groups: [],
                applications: [],
                processes: []
            },
            appsPayload: {
                pageSize: 50,
                pageNumber: 0,
                searchValue: ""
            },
            appToLoadPage: "",
            initialAppsDataLength: 0,
            moreOptions: [],
            initialPageNumber: 0,
            initialPageSize: 10,
            resetSearchValue: false,
            keepFilters: false,
            persistentOpsName: ""
        };
    },
    computed: {
        ...mapGetters("tasks", ["getSelectedTasksFilter", "selectedSortAndColumns"]),
        ...mapGetters("apps", ["apps"]),
        ...mapGetters("userProfile", ["userDataDetails", "getUserIsManager"]),
        ...mapState("main", ["activePage"]),
        ...mapState("dashboard", ["removeRouteQuery"]),

        getAllGroupsProps() {
            return {
                label: this.$t("appTasksContainer.selectGroup"),
                options: this.dataGroupsOptions,
                popoverAnchorPosition: "bottom left",
                popoverSelfPosition: "top left",
                resetSelectedData: this.resetAllSelectedData,
                disable: this.bulkTypeSelected,
                updateValue: true,
                addSearch: true,
                persistentMenuOps: this.updateTaskList && this.persistentOpsName === "groupId"
            };
        },
        showEmptyState() {
            return !this.allTasksData.length && !this.loadingTable && !this.searchTasks && !this.filterTaskData.tasks.length
            && !this.filterTaskData.statuses.length && !this.filterTaskData.users.length && !this.$route.query.filter
            && !this.filterTaskData.groups.length && !this.filterTaskData.applications.length && !this.filterTaskData.processes.length;
        },
        getTableProps() {
            return {
                atId: "tasks-table",
                noDataDefaultTableHeight: "56px",
                columns: this.columns,
                tableData: this.allTasksData,
                hidePagination: true,
                hideBottom: true,
                styledTable: true,
                rowColorSeparator: true,
                removeTableBorder: true,
                tableEmptyState: !this.searchTasks,
                noDescription: this.loadingTable || !!this.allTasksData.length
            };
        },
        getAllUsersProps() {
            return {
                label: this.$t("appTasksContainer.selectAllUsers"),
                options: this.usersListOptions,
                addSearch: true,
                hasAvatar: true,
                hasCheckbox: true,
                isMultiselect: true,
                clearableChip: true,
                disable: this.bulkTypeSelected,
                popoverAnchorPosition: "bottom left",
                popoverSelfPosition: "top left",
                resetSelectedData: this.resetSelectedUsers || this.resetAllSelectedData,
                persistentMenuOps: this.updateTaskList && this.persistentOpsName === "users"
            };
        },
        getAllApplicationsProps() {
            return {
                label: this.$t("appTasksContainer.selectAllApps"),
                options: this.appsOptions,
                hasCheckbox: true,
                addSearch: true,
                isMultiselect: true,
                clearableChip: true,
                hasPagination: true,
                hasAvatar: true,
                disable: this.bulkTypeSelected,
                popoverAnchorPosition: "bottom left",
                popoverSelfPosition: "top left",
                resetSelectedData: this.resetSelectedApps || this.resetAllSelectedData,
                persistentMenuOps: this.updateTaskList && this.persistentOpsName === "applications"
            };
        },
        getAllStatusesProps() {
            return {
                label: this.$t("appTasksContainer.selectAllStatus"),
                options: this.filterStatusOptions,
                hasCheckbox: true,
                isMultiselect: true,
                disable: this.bulkTypeSelected,
                clearableChip: true,
                popoverAnchorPosition: "bottom left",
                popoverSelfPosition: "top left",
                resetSelectedData: this.resetSelectedFilt || this.resetAllSelectedData,
                persistentMenuOps: this.updateTaskList && this.persistentOpsName === "statuses"
            };
        },
        getAllProcessesProps() {
            return {
                label: this.$t("appTasksContainer.selectAllProcesses"),
                options: this.processesOptions,
                hasCheckbox: true,
                isMultiselect: true,
                clearableChip: true,
                disable: !this.filterTaskData.applications.length || this.bulkTypeSelected,
                hasPagination: true,
                hasAvatar: true,
                popoverAnchorPosition: "bottom left",
                popoverSelfPosition: "top left",
                resetSelectedData: this.resetAllSelectedData,
                persistentMenuOps: this.updateTaskList && this.persistentOpsName === "processes"
            };
        },
        getAllTasksProps() {
            return {
                label: this.$t("appTasksContainer.selectAllTasks"),
                options: this.allTasksClaimed,
                popoverAnchorPosition: "bottom left",
                popoverSelfPosition: "top left",
                resetSelectedData: this.resetSelectedFilt || this.resetAllSelectedData,
                disable: this.bulkTypeSelected,
                persistentMenuOps: this.updateTaskList && this.persistentOpsName === "tasks",
                clearable: true
            };
        },
        getReassignUserList() {
            const userList = [...this.dataUsersList];
            userList.unshift(this.managerDetailsData);
            return userList;
        },
        setTaskNamePadding() {
            return this.showColSettings && this.columnsListToShow.length < 5 && !this.columnsListToShow.includes("priority") && !this.bulkTypeSelected;
        },
        setStatusDisplay() {
            const checkType = (this.type === "myOpenTasks" || this.type === "teamsTasks" || this.dashboardType === "team");
            return this.showColSettings ? this.columnsListToShow.includes("status") : checkType;
        },
        showCheckboxTaskName() {
            return this.bulkTypeSelected && this.showColSettings && this.columnsListToShow.length < 5 && !this.columnsListToShow.includes("priority");
        },
        checkAvailabelTaskComponent() {
            return this.type === "myOpenTasks" || this.dashboardType === "user";
        },
        checkTypeValidation() {
            return this.type !== "completedTasks" && this.type !== "myOpenTasks";
        },
        checkTypeComponent() {
            return this.type === "myOpenTasks" || this.type === "teamsTasks" || this.dashboardType === "team";
        },
        checkCompleted() {
            return (this.type === "completedTasks" || this.type === "completedTeamsTasks") && this.columnsListToShow.includes("completionDate");
        },
        showUsersFilter() {
            return this.type === "teamsTasks" || this.dashboardType === "team" || this.type === "completedTeamsTasks";
        },
        showGroupsFilter() {
            return (this.type === "teamsTasks" && !this.dashboard) || this.type === "completedTeamsTasks";
        },
        noFiltersApplied() {
            const hasFilters = Object.values(this.filterTaskData).some(filter => filter.length);
            return !(this.searchTasks || hasFilters);
        }
    },
    watch: {
        $route: {
            handler() {
                this.$nextTick(() => {
                    if (this.updateTaskList) {
                        this.persistentOpsName = "";
                        this.$emit("update:updateTaskList", false);
                    }
                });
            }
        },
        type: {
            handler(newValue) {
                if (newValue) {
                    this.getDataFirstTime = true;
                    if (newValue !== "teamsTasks") {
                        this.cancelBulk();
                    }
                    if (newValue === "completedTasks") {
                        this.defaultColumnSettings = SETTINGS_COLUMNS_COMPLETED;
                    } else if (newValue === "completedTeamsTasks") {
                        this.defaultColumnSettings = SETTINGS_COLUMNS_TEAMS_COMPLETED;
                    } else if (newValue === "teamsTasks") {
                        this.defaultColumnSettings = SETTINGS_ALL_COLUMNS;
                    } else {
                        this.defaultColumnSettings = SETTINGS_COLUMNS_MY_OPEN;
                    }

                    this.checkTypeForSettings(newValue);
                    this.initialStorageData = null;

                    this.tasksDisplayPayload = {
                        pageSize: 10,
                        pageNumber: 0,
                        sortBy: "",
                        sortType: "",
                        groupId: "",
                        users: [],
                        applications: [],
                        processes: [],
                        statuses: [],
                        searchValue: "",
                        type: this.type,
                        activeTasks: !this.tasksCompletedTypes.includes(this.type)
                    };
                    setTimeout(() => {
                        this.resetAllSelectedData = true;
                    }, 0);
                    Object.keys(this.filterTaskData).forEach(key => {
                        this.filterTaskData[key] = [];
                    });

                    this.noDataLoaded = true;
                    this.currentSortingPreferences = {};
                    this.getSortAndColumnsPreferences();
                    setTimeout(() => {
                        this.resetAllSelectedData = false;
                    }, 0);
                }
                const { query } = this.$route;
                if (this.searchTasks && (!query || !query.search)) {
                    this.resetSearchValue = true;
                    setTimeout(() => {
                        this.resetSearchValue = false;
                    }, 0);
                }
            }
        },
        dashboardType: {
            handler(newValue) {
                if (newValue) {
                    this.checkTypeForSettings(newValue);
                }
            }
        },
        getSelectedTasksFilter: {
            handler(newValue) {
                if (newValue) {
                    if (newValue.groupId && (this.type === "teamsTasks" || this.dashboardType === "team")) {
                        this.filterTaskDataChanged(newValue.groupId, "groupId");
                    }
                    if (newValue.applications && newValue.applications.length && this.filterTaskData.applications.length) {
                        if (newValue.applications[0] !== this.filterTaskData.applications[0].value) {
                            [this.appToLoadPage] = newValue.applications;
                        }
                    }
                }
            },
            immediate: true
        },
        resetFilters: {
            handler(newValue) {
                this.resetAllSelectedData = newValue;
                this.resetSearchValue = newValue;
                if (newValue) {
                    this.defaultStatusesValue = [];
                    this.defaultTasksValue = [];
                    this.defaultProcessesValue = [];
                    this.defaultUsersValue = [];
                }
            }
        },
        resetSelectedValues: {
            handler(newValue) {
                if (newValue) {
                    const defaultTaskType = {
                        onlyAvailable: false,
                        onlyClaimed: false,
                        onlyDelegated: false
                    };
                    const defaultValues = {
                        pageSize: 10,
                        pageNumber: 0,
                        sortBy: "",
                        sortType: "",
                        users: [],
                        applications: [],
                        processes: [],
                        statuses: [],
                        searchValue: "",
                        type: this.type,
                        activeTasks: !COMPLETED_TASKS_COMPONENTS.includes(this.type),
                        ...(this.dashboardType === "user" ? defaultTaskType : {})
                    };
                    this.tasksDisplayPayload = { ...this.tasksDisplayPayload, ...defaultValues };
                    this.filterTaskData.applications = [];
                    this.getAllTasks();
                }
            }
        },
        searchValue: {
            handler(value) {
                if (value) {
                    const searchV = value.trim();
                    if (searchV && searchV.length > 3) {
                        this.appsPayload.pageNumber = 0;
                        this.searchAppsData(searchV);
                    }
                } else {
                    this.appsPayload.pageNumber = 0;
                    this.searchAppsData();
                }
            }
        },
        "$backendDrivenEvents.state.refreshTasks": function (v) {
            if (v && this.type === "myOpenTasks") {
                this.getCurrentTasks();

                setTimeout(() => {
                    this.$backendDrivenEvents.state.refreshTasks = false;
                }, 1000);
            } else {
                this.$backendDrivenEvents.state.refreshTasks = false;
            }
        }
    },
    created() {
        if (this.type === "completedTasks") {
            this.defaultColumnSettings = SETTINGS_COLUMNS_COMPLETED;
        } else if (this.type === "completedTeamsTasks") {
            this.defaultColumnSettings = SETTINGS_COLUMNS_TEAMS_COMPLETED;
        } else if (this.type === "teamsTasks") {
            this.defaultColumnSettings = SETTINGS_ALL_COLUMNS;
        } else {
            this.defaultColumnSettings = SETTINGS_COLUMNS_MY_OPEN;
        }
        this.showSettingsBtn = this.type === "teamsTasks" && this.showColSettings && !this.dashboard;

        this.managerDetailsData = {
            avatarPath: this.userDataDetails.avatarPath,
            email: this.userDataDetails.email,
            id: this.userDataDetails.id,
            name: `${this.userDataDetails.firstName} ${this.userDataDetails.lastName}`
        };

        this.searchAllTasks = debounce(() => {
            this.tasksDisplayPayload.pageNumber = 0;
            this.tasksDisplayPayload.searchValue = this.searchTasks.trim();

            if (this._inactive) {
                this.loadingTable = true;
            } else {
                this.getAllTasks();
            }
        }, 600);
        this.checkQueryParams();
        if (this.type === "myOpenTasks" || this.type === "completedTasks") {
            this.tasksDisplayPayload.statuses = this.getSelectedTasksFilter.statuses || [];
            this.tasksDisplayPayload.applications = this.getSelectedTasksFilter.applications || [];
        }
        this.getSortAndColumnsPreferences();
        this.checkTypeForSettings(this.type);
    },
    deactivated() {
        this.tasksDisplayPayload.type = "myOpenTasks";
        this.tasksDisplayPayload.groupId = "";
        this.resetSelectedApps = true;
        this.resetSelectedFilt = true;
        if (!this.keepFilters) {
            this.$store.commit("tasks/setSelectedTasksFilter", { applications: [] });
        }
        this.loadingTable = true;
        if (this.showButtonBulkUnclaim || this.showButtonBulkReassign) {
            this.cancelBulk();
        }
        setTimeout(() => {
            this.resetSelectedApps = false;
            this.resetSelectedFilt = false;
        }, 0);
    },
    methods: {
        ...mapActions("tasks", ["getAllTasks", "getAllFilteredTasks", "getMyTeamGroups", "getTaskInformation", "saveTasksSortAndColumns", "getSortAndColumns"]),
        ...mapActions("apps", ["getAppsWithPagination", "getAppsByIds", "getAppProcesses"]),
        ...mapMutations("tasks", ["setSelectedTasksFilter"]),
        setShowOps(name) {
            if (this.updateTaskList) {
                this.persistentOpsName = "";
                this.$nextTick(() => {
                    this.$emit("update:updateTaskList", false);
                });
            } else {
                this.persistentOpsName = name || "";
                this.$emit("openedDropdown", !!this.persistentOpsName);
            }
        },
        searchForItems(searchValue) {
            this.searchTasks = searchValue;
            if (!this.searchTasks) {
                this.openSearch = false;
            }
            if (!this.searchTasks || (this.searchTasks && this.searchTasks.length > 2)) {
                this.searchAllTasks();
            }
        },
        checkQueryParams() {
            const { query, name } = this.$route;
            const setQueryFromRoute = () => (["mydashboard", "myteamsdashboard"].includes(name) ? !this.removeRouteQuery : true);

            if (!(this.dashboardType === "team" && name === "mydashboard") && Object.keys(query).length && setQueryFromRoute()) {
                let usersValue = [];
                const getQueryData = () => {
                    let queryParams = {};
                    const { applications, available, claimed, delegated, pageNumber, groupId, users,
                        pageSize, processes, search, sortBy, sortType, statuses } = query;

                    const setQueryData = (data, type) => {
                        if (type === "processes") {
                            this.defaultProcessesValue = data.split(",");
                        } else if (type === "users") {
                            usersValue = data.split(",");
                        } else if (type === "statuses") {
                            this.defaultStatusesValue = data.split(",");
                        }
                        return { [type]: data.split(",") };
                    };
                    const addAppsAndProcess = () => ({ applications: applications.split(","), ...(processes ? setQueryData(processes, "processes") : {}) });
                    queryParams = {
                        ...(applications ? addAppsAndProcess() : {}),
                        ...(pageNumber ? { pageNumber: JSON.parse(pageNumber) } : {}),
                        ...(pageSize ? { pageSize: JSON.parse(pageSize) } : {}),
                        ...(search ? { searchValue: search } : {}),
                        ...(sortBy ? { sortBy } : {}),
                        ...(sortType ? { sortType } : {}),
                        ...(groupId ? { groupId } : {}),
                        ...(available ? { onlyAvailable: JSON.parse(available) } : {}),
                        ...(claimed ? { onlyClaimed: JSON.parse(claimed) } : {}),
                        ...(delegated ? { onlyDelegated: JSON.parse(delegated) } : {}),
                        ...(statuses ? setQueryData(statuses, "statuses") : {}),
                        ...(users ? setQueryData(users, "users") : {})
                    };
                    this.$nextTick(() => {
                        this.searchTasks = search || "";
                        this.openSearch = !!this.searchTasks;
                    });

                    return queryParams;
                };
                const defaultPayload = {
                    pageSize: 10,
                    pageNumber: 0,
                    sortBy: "",
                    sortType: "",
                    groupId: "",
                    users: [],
                    applications: [],
                    processes: [],
                    statuses: [],
                    searchValue: "",
                    type: this.type,
                    activeTasks: !COMPLETED_TASKS_COMPONENTS.includes(this.type)
                };
                this.initialStorageData = {
                    __myTeamsFilters: { ...defaultPayload, ...getQueryData() }
                };
                if (usersValue.length) {
                    this.defaultUsersValue = usersValue;
                    this.savedUsers = usersValue;
                }

                this.getTaskSelectedOption();

                this.getStatusesSelectedOptions();
                this.getUsersSelectedOptions();
                const { tasks } = this.filterTaskData;
                this.defaultTasksValue = tasks && tasks.length ? [tasks[0].value] : [];
            }

            this.showSettingsBtn = this.type === "teamsTasks" && this.showColSettings && !this.dashboard;
            this.$nextTick(() => {
                if (this.removeRouteQuery) {
                    this.$store.commit("dashboard/setRemoveRouteQuery", false);
                }
                this.defaultTasksValue = [];
                this.defaultStatusesValue = [];
            });
        },
        viewAllTasks() {
            const query = { tab: "todo", ...this.getFiltersForQuery() };
            if (this.dashboardType === "team") {
                this.$store.commit("main/setFromMyTeamsTasksMenu", true);
                this.$router.push({ path: "/tasks/teamTasks", query });
            } else {
                this.keepFilters = true;
                this.$store.commit("main/setFromMyTeamsTasksMenu", false);
                this.$store.commit("tasks/setSelectedTasksFilter",
                    { applications: this.tasksDisplayPayload.applications,
                        statuses: this.tasksDisplayPayload.statuses });
                this.$router.push({ path: "/tasks/myTasks", query });
            }
        },
        getTooltipHeader(status) {
            let statusToReturn = this.$t("appTasksContainer.onTrack");
            if (status === "OVERDUE") {
                statusToReturn = this.$t("appTasksContainer.overdue");
            } else if (status === "AT_RISK") {
                statusToReturn = this.$t("appTasksContainer.atRisk");
            } else if (status === "ATTENTION") {
                statusToReturn = this.$t("appTasksContainer.attention");
            }
            return statusToReturn;
        },
        getStatusesSelectedOptions() {
            let result = [];
            if (this.initialStorageData && this.initialStorageData.__myTeamsFilters) {
                result = this.initialStorageData.__myTeamsFilters.statuses;
            } else {
                result = this.getSelectedTasksFilter && this.getSelectedTasksFilter.statuses ? this.getSelectedTasksFilter.statuses : this.$route.query.filter;
            }
            if (result && result.length) {
                if (Array.isArray(result)) {
                    this.defaultStatusesValue = result;
                } else {
                    this.defaultStatusesValue.push(result);
                }
                if (this.getSelectedTasksFilter && this.getSelectedTasksFilter.statuses) {
                    const selectedTasksFilter = { ...this.getSelectedTasksFilter };
                    delete selectedTasksFilter.statuses;
                    this.$store.commit("tasks/setSelectedTasksFilter", selectedTasksFilter);
                }
            }
        },
        getUsersSelectedOptions() {
            let result = [];
            if (this.savedUsers && this.savedUsers.length) {
                result = this.savedUsers;
            } else {
                result = this.getSelectedTasksFilter && this.getSelectedTasksFilter.users ? this.getSelectedTasksFilter.users : null;
            }
            if (result && result.length) {
                this.filterTaskData.users = this.usersListOptions.filter(elem => result.includes(elem.value));
            }
        },
        getGroupsSelectedOptions() {
            let result = "";
            if (this.initialStorageData && this.initialStorageData.__myTeamsFilters) {
                result = this.initialStorageData.__myTeamsFilters.groupId;
            } else {
                result = this.getSelectedTasksFilter && this.getSelectedTasksFilter.groupId ? this.getSelectedTasksFilter.groupId : null;
            }
            if (result) {
                this.filterTaskData.groups = this.dataGroupsOptions.filter(elem => elem.value === result);
            }
        },
        getAppsSelectedOptions() {
            let result = [];
            if (this.initialStorageData && this.initialStorageData.__myTeamsFilters) {
                result = this.initialStorageData.__myTeamsFilters.applications;
            } else {
                result = this.getSelectedTasksFilter && this.getSelectedTasksFilter.applications ? this.getSelectedTasksFilter.applications : null;
            }
            if (result && result.length) {
                this.getAppsByIds(result).then(data => {
                    this.setAppsOptions(data);
                    this.filterTaskData.applications = this.appsOptions.filter(elem => result.includes(elem.value));
                    this.createProcessList();
                });
            }
        },
        createProcessList() {
            if (this.filterTaskData.applications.length) {
                const promises = [];
                this.filterTaskData.applications.forEach(el => {
                    promises.push(this.getAppProcesses({ applicationId: el.value, searchTerm: "" }));
                });
                Promise.all(promises).then(
                    response => {
                        const processData = [];
                        if (response && response.length) {
                            response.forEach(rsp => {
                                if (rsp.data) {
                                    rsp.data.forEach(item => {
                                        processData.push({ label: item.name, value: item.id });
                                    });
                                }
                            });
                        }

                        this.processesOptions = processData;
                    }
                );
            } else {
                this.processesOptions = [];
            }
        },
        refreshData(data, property) {
            if (property === "statuses" && !data.statuses.length) {
                this.tasksDisplayPayload.statuses = [];
            } else if (property === "applications" && !data.applications.length) {
                this.defaultProcessesValue = [];
                this.$refs.processesRef.clearValue();
                this.tasksDisplayPayload.applications = [];
            }
            this.tasksDisplayPayload.pageNumber = 0;
            this.getAllTasks();
        },
        checkCall(data, property) {
            if (property === "groupId") {
                this.changeUserList = true;
                setTimeout(() => {
                    this.resetSelectedUsers = true;
                }, 0);
                this.filterTaskData.users = [];
                this.tasksDisplayPayload.groupId = data.length ? data[0].value : "";
                this.bulkCheckboxSelectedTasks = [];
                this.tasksDisplayPayload.pageNumber = 0;
                this.tasksDisplayPayload.users = [];
                setTimeout(() => {
                    this.resetSelectedUsers = false;
                }, 0);
            } else if (property === "tasks" && data && data.length) {
                this.tasksDisplayPayload.onlyAvailable = data[0].value === "onlyAvailable";
                this.tasksDisplayPayload.onlyClaimed = data[0].value === "onlyClaimed";
                this.tasksDisplayPayload.onlyDelegated = data[0].value === "onlyDelegated";
                this.tasksDisplayPayload.pageNumber = 0;
            } else if (property === "tasks" && (!data || !data.length)) {
                this.tasksDisplayPayload.onlyAvailable = false;
                this.tasksDisplayPayload.onlyClaimed = false;
                this.tasksDisplayPayload.onlyDelegated = false;
                this.tasksDisplayPayload.pageNumber = 0;
            } else {
                this.changeUserList = false;
                this.tasksDisplayPayload.pageNumber = 0;
                const dataToSend = data.map(elem => elem.value);
                this.tasksDisplayPayload[property] = dataToSend;
            }
            if (property === "applications") {
                this.defaultProcessesValue = [];
                this.$refs.processesRef.clearValue();
                this.createProcessList();
            }
            this.getAllTasks();
        },
        checkCallTasks: debounce(function (data, property) {
            this.checkCall(data, property);
        }, 600),
        removeDefaultUsers() {
            this.defaultUsersValue = [];
        },
        getTaskSelectedOption() {
            let result = [];
            if (this.initialStorageData && this.initialStorageData.__myTeamsFilters) {
                if (this.initialStorageData.__myTeamsFilters.onlyClaimed) {
                    result.push("onlyClaimed");
                } else if (this.initialStorageData.__myTeamsFilters.onlyAvailable) {
                    result.push("onlyAvailable");
                }
            } else if (this.getSelectedTasksFilter && (this.getSelectedTasksFilter.onlyAvailable || this.getSelectedTasksFilter.onlyClaimed)) {
                if (this.getSelectedTasksFilter.onlyClaimed) {
                    result.push("onlyClaimed");
                } else if (this.getSelectedTasksFilter.onlyAvailable) {
                    result.push("onlyAvailable");
                }
            } else {
                result = this.$route.query.filter;
            }
            if (result && result.length) {
                this.filterTaskData.tasks = this.allTasksClaimed.filter(elem => elem.value === result[0]);
            }
        },
        loadMoreTasks() {
            this.tasksDisplayPayload.pageNumber++;
            this.getAllTasks(true);
        },
        hideAppsDDL() {
            this.setShowOps();
            this.searchValue = "";
        },
        hideProcessesDDL() {
            this.setShowOps();
            this.searchValue = "";
        },
        checkIfEllipsis(ref) {
            const { [ref]: el } = this.$refs;
            if (el) {
                this.showTooltip = el.scrollHeight > el.clientHeight;
            }
        },
        showResults(name) {
            this.setShowOps(name);
            this.optionsMenu = this.$refs.applicationsRef.$refs.menuDropdown.$children[0].$children[0].$children[1].$el;
            if (this.optionsMenu && this.optionsMenu.offsetHeight) {
                const checkSearch = this.optionsMenu.offsetHeight < 100;
                if (checkSearch && this.getSelectedTasksFilter.application) {
                    this.optionsMenu = this.$refs.applicationsRef.$refs.menuDropdown.$children[0].$children[0].$children[0].$el;
                }
            }
            this.appToLoadPage = "";
            this.optionsMenu.addEventListener("scroll", () => {
                if (this.optionsMenu.offsetHeight + this.optionsMenu.scrollTop >= this.optionsMenu.scrollHeight) {
                    this.searchAppsData(null, true, true);
                }
            });
            if (this.appsOptions.length !== this.initialAppsDataLength) {
                this.appsPayload.pageNumber = 0;
                this.searchAppsData();
            }
        },
        getSearchValue(value) {
            this.searchValue = value;
        },
        searchAppsData(value, loadMore, fromScroll) {
            this.appsPayload.searchValue = value || "";
            this.appsPayload.pageSize = 50;
            if (loadMore) {
                this.appsPayload.pageNumber++;
                this.getAllAppsOptions(loadMore, fromScroll);
            } else {
                this.getAllAppsOptions();
            }
        },
        goTopHeader() {
            this.parentInstanceId = document.getElementById("tasks-content");
            if (this.parentInstanceId) {
                this.parentInstanceId.scrollTop = 0;
            }
        },
        setDataGroupsOptions(data) {
            this.dataGroupsOptions = data.map(elem => {
                let type = "";
                const toReturn = {};
                let isDisabled = false;
                let groupsInfo = "";
                let nrGroups = "";
                let nrUsers = "";

                if (elem.sourceType === "AD" || elem.systemType === "EXTERNAL") {
                    type = "externalGroup";
                } else if (elem.systemType === "APPLICATION") {
                    type = "applicationSpecific";
                } else {
                    type = "platform";
                }
                if (elem.nrOfGroups && parseInt(elem.nrOfGroups, 10)) {
                    nrGroups = this.$tc("dashboard.nrOfGroups", parseInt(elem.nrOfGroups, 10), { count: parseInt(elem.nrOfGroups, 10) });
                }
                if (elem.nrOfUsers && parseInt(elem.nrOfUsers, 10)) {
                    nrUsers = this.$tc("dashboard.nrOfUsers", parseInt(elem.nrOfUsers, 10), { count: parseInt(elem.nrOfUsers, 10) });
                }
                if (elem.nrOfGroups && parseInt(elem.nrOfGroups, 10) && elem.nrOfUsers && parseInt(elem.nrOfUsers, 10)) {
                    groupsInfo = nrGroups + this.$t("admin.usersAndRoles.and") + nrUsers;
                } else if (elem.nrOfGroups && parseInt(elem.nrOfGroups, 10) && elem.nrOfUsers && !parseInt(elem.nrOfUsers, 10)) {
                    groupsInfo = nrGroups;
                } else if (elem.nrOfGroups && !parseInt(elem.nrOfGroups, 10) && elem.nrOfUsers && parseInt(elem.nrOfUsers, 10)) {
                    groupsInfo = nrUsers;
                }

                isDisabled = (elem.status === "DISABLED");
                toReturn.label = elem.name;
                toReturn.description = groupsInfo;
                toReturn.avatarProps = { type, avatarDisabled: isDisabled };
                toReturn.elementType = "group";
                toReturn.value = elem.id;

                return toReturn;
            });
        },
        setUsersOptions(data) {
            this.usersListOptions = data.map(elem => {
                let type = "";
                let path = null;
                const toReturn = {};
                let isDisabled = false;
                let userName = "";

                if (elem.systemType === "TOAUTHUSR") {
                    type = "systemExternalUser";
                } else if (elem.systemType === "TSYS") {
                    type = "systemInternalUser";
                } else {
                    path = (elem && elem.avatar) ? `/identity/tenants/users/image/${elem.id}/s` : null;
                    type = (elem.sourceType === "AD" || elem.systemType === "TSAMLUSR"
                        || elem.systemType === "TOPENIDUSR" || elem.realmId) ? "externalUser" : "userPlatform";
                }
                if (elem.name && elem.lastName) {
                    if (elem.systemType === "TOAUTHUSR") {
                        const externalCode = elem.code ? ` [${elem.code}] ` : " ";
                        userName = elem.name.concat(externalCode, elem.lastName);
                    } else {
                        userName = elem.name.concat(" ", elem.lastName);
                    }
                } else if (!elem.name) {
                    userName = elem.lastName;
                } else if (!elem.lastName) {
                    userName = elem.name;
                }
                isDisabled = (elem.status === "DISABLED");
                toReturn.label = userName || elem.email;
                toReturn.description = userName ? elem.email : "";
                toReturn.isDisabledUser = elem.status === "DISABLED";
                toReturn.avatarProps = { type, avatarDisabled: isDisabled, customAvatar: path };
                toReturn.elementType = "user";
                toReturn.value = elem.id;

                return toReturn;
            });
        },
        filterTaskDataChanged(data, property) {
            if (property === "groupId") {
                this.changeUserList = true;
                setTimeout(() => {
                    this.resetSelectedUsers = true;
                }, 0);
                this.filterTaskData.users = [];
                this.tasksDisplayPayload.groupId = data || "";
                this.bulkCheckboxSelectedTasks = [];
                this.tasksDisplayPayload.pageNumber = 0;
                this.tasksDisplayPayload.users = [];
                setTimeout(() => {
                    this.resetSelectedUsers = false;
                }, 0);
            }
            this.getAllTasks();
        },
        sortTasks: debounce(function (data) {
            this.currentSortValue = data.sortBy;
            this.tasksDisplayPayload.sortBy = data.sortBy;
            this.tasksDisplayPayload.sortType = data.sortType;
            this.saveSortAndColumnsPreferences();
            this.refreshTasksDataList();
        }, 600),

        getFiltersForQuery() {
            const newQuery = {};
            const checkObjectData = (v) => (v.constructor === "Object" ? !!Object.keys(v).length : true);
            const checkArrayData = (v) => (Array.isArray(v) ? !!v.length : true);

            const propList = ["searchValue", "onlyAvailable",
                "onlyClaimed", "onlyDelegated", "statuses", "applications", "processes", "users", "groupId"];
            const propListToShow = {
                searchValue: "search",
                onlyAvailable: "available",
                onlyClaimed: "claimed",
                onlyDelegated: "delegated"
            };
            propList.forEach(currentProp => {
                const currentPropData = this.tasksDisplayPayload[currentProp];
                if (currentPropData && checkObjectData(currentPropData) && checkArrayData(currentPropData)) {
                    const getCustomProp = propListToShow[currentProp];
                    if (getCustomProp) {
                        newQuery[getCustomProp] = currentProp === "searchValue" ? this.searchTasks : currentPropData.toString();
                    } else {
                        newQuery[currentProp] = currentPropData.toString();
                    }
                }
            });

            return newQuery;
        },

        getAllTasks: debounce(function (loadMore, fromRefresh) {
            const { name: routeName } = this.$route;
            if (this.dashboardType === "team" && routeName === "mydashboard") {
                return;
            }
            if (this.$route.query.filter && !this.currentQueryParams) {
                this.currentQueryParams = this.$route.query.filter;
                const queryArray = [this.$route.query.filter];
                this.tasksDisplayPayload.statuses = queryArray[0] !== "ALL" ? queryArray : [];
                this.filterTaskData.statuses = queryArray[0] !== "ALL" ? queryArray : [];
                this.getStatusesSelectedOptions();
            }
            this.tasksDisplayPayload.type = this.dashboardType === "team" ? "teamsTasks" : this.tasksDisplayPayload.type;
            this.tasksDisplayPayload.activeTasks = !this.tasksCompletedTypes.includes(this.type);
            if (["myOpenTasks", "completedTasks"].includes(this.tasksDisplayPayload.type)) {
                this.tasksDisplayPayload.groupId = "";
            }
            if (this.type === "completedTeamsTasks" && !this.tasksDisplayPayload.sortBy && !this.tasksDisplayPayload.sortType) {
                this.tasksDisplayPayload.sortBy = "completionDate";
                this.tasksDisplayPayload.sortType = "DESC";
            }
            this.loadingTable = true;
            const { path, query: queryCurrentPath, fullPath } = this.$route;
            const getSelectedTab = this.selectedTab && !this.dashboardType ? { tab: this.selectedTab } : {};
            const query = { ...getSelectedTab, ...this.getFiltersForQuery() };
            const checkMatchRoute = this.$router.match({ path, query });
            if (!["appUserTaskDataViews", "appUserTaskAnalytics", "appUserTask"].includes(routeName)
             && fullPath !== checkMatchRoute.fullPath && (Object.keys(query).length || Object.keys(queryCurrentPath).length)) {
                if (this.dashboardType === "team" && path.includes("mydashboard")) {
                    this.$router.replace({ path: "/myteamsdashboard", query });
                } else {
                    this.$router.replace({ query });
                }
            }

            this.getAllFilteredTasks(this.tasksDisplayPayload).then(
                data => {
                    let allTasks = [];
                    this.selectAllTasks = false;
                    if (!loadMore) {
                        this.showButtonBulkUnclaim = false;
                        this.showButtonBulkReassign = false;
                    }

                    if (fromRefresh) {
                        this.tasksDisplayPayload.pageNumber = this.initialPageNumber;
                        this.tasksDisplayPayload.pageSize = this.initialPageSize;
                    }

                    if (data.tasks) {
                        this.noDataLoaded = false;
                        allTasks = data.tasks.map((current) => {
                            if (current.canUnclaim && !this.showButtonBulkUnclaim) {
                                this.showButtonBulkUnclaim = true;
                            }
                            if (current.canReassign && !this.showButtonBulkReassign) {
                                this.showButtonBulkReassign = true;
                            }

                            const allFilteredTasks = this.transformData(current);
                            if (this.bulkTypeSelected) {
                                const checkCanUnclaim = (this.bulkTypeSelected === "UNCLAIM" && allFilteredTasks.canUnclaim);
                                const checkCanReassign = (this.bulkTypeSelected === "REASSIGN" && allFilteredTasks.canReassign);
                                if (checkCanUnclaim || checkCanReassign) {
                                    this.allTasksListIds.push(allFilteredTasks.taskId);
                                }
                            }
                            return allFilteredTasks;
                        });
                    }
                    if (loadMore) {
                        this.allTasksData = this.allTasksData.concat(allTasks || []);
                    } else {
                        this.allTasksData = allTasks || [];
                    }

                    if (this.checkAvailabelTaskComponent && !this.filterTaskData.tasks.length) {
                        this.getTaskSelectedOption();
                    }
                    if (this.getDataFirstTime && this.checkTypeComponent && !this.filterTaskData.statuses.length) {
                        this.getStatusesSelectedOptions();
                    }
                    if (this.getDataFirstTime) {
                        this.getDataFirstTime = false;
                    }

                    this.allTasksTotalCount = data.totalCount || 0;
                    if (this.changeUserList) {
                        this.dataUsersList = data.users || [];
                    }
                    if (data.users && data.users.length) {
                        this.setUsersOptions(data.users);
                        if (this.showUsersFilter && !this.filterTaskData.users.length) {
                            this.getUsersSelectedOptions();
                        }
                    }
                    this.changeUserList = false;
                    this.loadingTable = false;
                }
            );
        }, 600),
        bulkOptionActionSelected(selection) {
            this.allTasksListIds = [];
            if (selection) {
                this.allTasksData.forEach(item => {
                    if ((selection === "UNCLAIM" && item.canUnclaim) || (selection === "REASSIGN" && item.canReassign)) {
                        this.allTasksListIds.push(item.taskId);
                    }
                });
            }

            this.bulkTypeSelected = selection;
            this.selectAllTasks = false;
            this.bulkCheckboxSelectedTasks = [];
        },
        triggerBulkAction() {
            this.bulkUnclaimReassignModal = true;
        },
        cancelBulk() {
            this.bulkTypeSelected = null;
            this.selectAllTasks = false;
            this.bulkCheckboxSelectedTasks = [];
        },
        selectAllCheckbox(data) {
            this.bulkCheckboxSelectedTasks = data ? [...this.allTasksListIds] : [];
        },
        triggerCheckboxTask() {
            this.selectAllTasks = this.bulkCheckboxSelectedTasks.length === this.allTasksListIds.length;
        },
        unclaimReassignResponse() {
            if (this.bulkTypeSelected) {
                this.bulkTypeSelected = null;
                this.bulkCheckboxSelectedTasks = [];
                this.selectAllTasks = false;
            }
            this.refreshTasksDataList();
        },
        setAppsOptions(data, loadMore) {
            const appsList = data.map(elem => ({
                label: elem.name,
                value: elem.id,
                description: `${this.$t("apps.code")} ${elem.code}` || "N/A",
                avatarProps: { type: "app", customAvatar: elem.hasOwnProperty("imageUrl") ? this.getImagePath(elem.imageId) : null }
            }));
            if (loadMore) {
                this.appsOptions = this.appsOptions.concat(appsList);
            } else {
                this.appsOptions = [];
                this.appsOptions = appsList;
            }
        },
        getImagePath(id) {
            let path = null;
            if (id) {
                path = `${ENGINE_REST_PATH}/app/files/${id}/IMAGE`;
            }
            return path;
        },
        getAllAppsOptions(load, fromScroll, firstCall) {
            this.getAppsWithPagination(this.appsPayload).then(data => {
                if (data && data.length) {
                    this.setAppsOptions(data, load);
                    if (firstCall) {
                        this.initialAppsDataLength = data.length;
                    }
                    if (!this.filterTaskData.applications.length || this.appToLoadPage) {
                        this.getAppsSelectedOptions();
                    }
                } else if (!fromScroll) {
                    this.appsOptions = [{ label: this.$t("applicationPermissions.noResultsFound"), itemDisabled: true }];
                }
            });
        },
        getCurrentTasks() {
            if (this.type === "myOpenTasks" || this.type === "completedTasks") {
                if (this.initialStorageData && this.initialStorageData.__myTeamsFilters) {
                    this.tasksDisplayPayload = this.initialStorageData.__myTeamsFilters;
                }
                if (this.tasksDisplayPayload.type !== this.type) {
                    this.tasksDisplayPayload.type = this.type;
                    this.tasksDisplayPayload.pageNumber = 0;
                    this.tasksDisplayPayload.pageSize = 10;
                }
                this.tasksDisplayPayload.activeTasks = !this.tasksCompletedTypes.includes(this.type);
                this.refreshTasksDataList();
            } else if (this.type === "teamsTasks" || this.type === "completedTeamsTasks") {
                this.getMyTeamGroups(this.userDataDetails.id).then(
                    data => {
                        this.dataGroups = data || [];
                        if (data && data.length) {
                            this.setDataGroupsOptions(data);
                            if (this.showGroupsFilter && !this.filterTaskData.groups.length) {
                                this.getGroupsSelectedOptions();
                            }
                        }
                        this.changeUserList = true;
                        if (this.initialStorageData && this.initialStorageData.__myTeamsFilters) {
                            this.tasksDisplayPayload = this.initialStorageData.__myTeamsFilters;
                            if (!this.tasksDisplayPayload.groupId && ["teamsTasks", "completedTeamsTasks"].includes(this.tasksDisplayPayload.type)) {
                                this.tasksDisplayPayload.groupId = this.dataGroups[0] ? this.dataGroups[0].id : "";
                            }
                            if (this.tasksDisplayPayload.type !== this.type) {
                                this.tasksDisplayPayload.type = this.type;
                                this.tasksDisplayPayload.pageNumber = 0;
                                this.tasksDisplayPayload.pageSize = 10;
                            }
                        } else if (this.getSelectedTasksFilter && this.getSelectedTasksFilter.groupId) {
                            this.tasksDisplayPayload.groupId = this.getSelectedTasksFilter.groupId;
                        } else {
                            this.tasksDisplayPayload.groupId = this.dataGroups[0] ? this.dataGroups[0].id : "";
                        }
                        this.filterTaskData.groups = this.dataGroupsOptions.filter(elem => elem.value === this.tasksDisplayPayload.groupId);
                        this.refreshTasksDataList();
                    }
                );
            }
            this.getAllAppsOptions(false, false, true);
        },
        triggerChangeSettings() {
            this.columnListSettingsChanged = true;
        },
        checkTypeForSettings(data) {
            if (data === "myOpenTasks" || this.dashboardType === "user") {
                this.showColSettings = true;
                this.columnsListToShow = DEFAULT_COL_SETTINGS_OPEN;
            } else if (data === "teamsTasks" || this.dashboardType === "team") {
                this.showColSettings = true;
                this.columnsListToShow = DEFAULT_COL_SETTINGS_TEAM;
            } else if (data === "completedTasks") {
                this.showColSettings = true;
                this.columnsListToShow = DEFAULT_COL_SETTINGS_COMPLETED;
            } else if (data === "completedTeamsTasks") {
                this.showColSettings = true;
                this.columnsListToShow = DEFAULT_COL_SETTINGS_TEAM_COMPLETED;
            } else {
                this.showColSettings = false;
                this.columnsListToShow = SETTINGS_COLUMNS_MY_OPEN;
            }
            if (this.showColSettings) {
                this.selectedColumnSettings = [...this.columnsListToShow];
            }
        },
        changeColumnSettings(action) {
            if (action === "confirm") {
                this.columnsListToShow = [...this.selectedColumnSettings];
                this.columnListSettingsChanged = false;
                this.debounceSaveSortAndColumns();
            } else if (action === "default") {
                switch (this.type) {
                    case "myOpenTasks":
                        this.selectedColumnSettings = DEFAULT_COL_SETTINGS_OPEN;
                        this.columnsListToShow = this.selectedColumnSettings;
                        break;
                    case "teamsTasks":
                        this.selectedColumnSettings = DEFAULT_COL_SETTINGS_TEAM;
                        this.columnsListToShow = this.selectedColumnSettings;
                        break;
                    case "completedTasks":
                        this.selectedColumnSettings = DEFAULT_COL_SETTINGS_COMPLETED;
                        this.columnsListToShow = this.selectedColumnSettings;
                        break;
                    case "completedTeamsTasks":
                        this.selectedColumnSettings = DEFAULT_COL_SETTINGS_TEAM_COMPLETED;
                        this.columnsListToShow = this.selectedColumnSetting;
                        break;
                    default:
                        this.selectedColumnSettings = DEFAULT_COL_SETTINGS_OPEN;
                        this.columnsListToShow = this.selectedColumnSettings;
                }
                this.debounceSaveSortAndColumns();
            }
            this.$refs["ref-popover-settings"].hide();
        },
        hideSettings() {
            if (this.columnListSettingsChanged) {
                this.selectedColumnSettings = [...this.columnsListToShow];
            }
        },

        saveSortAndColumnsPreferences() {
            const payload = {
                sortBy: this.tasksDisplayPayload.sortBy,
                sortType: this.tasksDisplayPayload.sortType,
                columns: this.columnsListToShow = [...this.selectedColumnSettings],
                type: this.tasksDisplayPayload.type
            };
            this.saveTasksSortAndColumns(payload);
        },

        getSortAndColumnsPreferences() {
            this.getSortAndColumns(this.type).then(
                data => {
                    if (data && data.sortType) {
                        this.tasksDisplayPayload.sortBy = data.sortBy;
                        this.tasksDisplayPayload.sortType = data.sortType;
                        this.currentSortingPreferences = { ...data };
                    }
                    if (data && data.columns) {
                        this.selectedColumnSettings = data.columns;
                        this.columnsListToShow = data.columns;
                    }
                    this.getCurrentTasks();
                }
            );
        },
        debounceSaveSortAndColumns: debounce(function () {
            this.saveSortAndColumnsPreferences();
        }, 600),
        showAssignmentChip(props) {
            const { users, groups } = props;
            let show = false;
            if (["teamsTasks", "completedTeamsTasks"].includes(this.type) || this.dashboardType === "team") {
                show = (users && users.length) || (groups && groups.length);
            }
            return show;
        },
        assignmentChipType(props) {
            const { users, groups } = props;
            let type = "";
            if (users && users.length) {
                type = users[0].status === "DISABLED" ? "disabledUser" : "user";
            } else if (groups && groups.length) {
                type = "group";
            }
            return type;
        },
        assignmentChipContent(props) {
            const { users, groups } = props;
            let content = "";
            if (users && users.length) {
                if (users[0].firstName) {
                    content = users[0].firstName;
                }
                if (users[0].lastName) {
                    content = `${content} ${users[0].lastName}`.trim();
                }
                if (!content) {
                    content = users[0].email;
                }
            } else if (groups && groups.length) {
                content = groups[0].name;
            }
            return content;
        },
        getMoreOptions(data) {
            const { canUnclaim, canReassign } = data;
            const options = [];
            if (canUnclaim) {
                options.push({ label: this.$t("appTasksContainer.unclaimAction"), value: "UNCLAIM" });
            }
            if (canReassign) {
                options.push({ label: this.$t("appTasksContainer.reassignAction"), value: "REASSIGN" });
            }
            return options;
        },
        selectMoreOption(option, taskId) {
            if (option && option.length) {
                if (option[0].value === "UNCLAIM") {
                    this.openDlg(taskId, "UNCLAIM");
                } else if (option[0].value === "REASSIGN") {
                    this.openDlg(taskId, "REASSIGN");
                }
            }
        }
    }
};
